/**
 * Shared utilities.
 */

import Draggable from "gsap/Draggable";
import { gsap } from "gsap/all";

export const hideOnClickOutside = (element, bodyClass, elementClass) => {
	const outsideClickListener = event => {
		if (!element.contains(event.target)) {

			if( event.target.parentNode.dataset.dialog === element.id )
				return;

			// IF BODY CLASS
			if( bodyClass ){
				document.body.classList.remove(bodyClass)
			}

			// IF ELEMENT CLASS
			if( elementClass ){
				if( elementClass.constructor.name == "Array" ){
					element.classList.remove(...elementClass)
				} else {
					element.classList.remove(elementClass)
				}
			}

			// REMOVE CLICK LISTENER
			removeClickListener();

			// console.log('removed click listener')

			if(window.app.smoother){
				window.app.smoother.paused(false);
				// console.log('unpaused scroller')
			}
		}
	}

	const removeClickListener = () => {
		document.removeEventListener('click', outsideClickListener);
	}

	document.addEventListener('click', outsideClickListener);
}

	
export const lazyLoadImage = (img) => {
	const src = img.getAttribute("data-src");
	const type = img.getAttribute("loading");
	if (type == "lazy") {
		img.classList.add("lazy--loaded");
	}
	if (!src) {
		return;
	}
	var image = new Image();
	image.src = src;
	image.onload = function () {
		img.src = image.src;
		img.classList.add("lazy--loaded");
	};
};

export const lazyBackground = (img) => {
	const src = img.getAttribute("data-background");
	if (!src) {
		return;
	}
	var image = new Image();
	image.src = src;
	image.onload = function () {
		img.style.backgroundImage = 'url("' + image.src + '")';
		img.classList.add("lazy--loaded");
	};
};

// Linear interpolation
export const lerp = (a, b, n) => (1 - n) * a + n * b;

// Gets the mouse position, attach to an event listener...
export const getMousePos = (e) => {
	let posx = 0;
	let posy = 0;
	if (!e) e = window.event;
	if (e.clientX || e.clientY) {
		posx = e.clientX;
		posy = e.clientY;
	}
	return { x: posx, y: posy };
};

// Get sibilings
export const getSiblings = (e) => {
	// for collecting siblings
	let siblings = [];
	// if no parent, return no sibling
	if (!e.parentNode) {
		return siblings;
	}
	// first child of the parent node
	let sibling = e.parentNode.firstChild;
	// collecting siblings
	while (sibling) {
		if (sibling.nodeType === 1 && sibling !== e) {
			siblings.push(sibling);
		}
		sibling = sibling.nextSibling;
	}
	return siblings;
};

export const getDimensions = (el) => {
	return (
		el.classList[0] +
		" dimensions are " +
		"width - " +
		el.offsetWidth +
		" and height - " +
		el.offsetHeight
	);
};

export const convertToSlug = (text) => {
	return text
		.toLowerCase()
		.replace(/ /g, "-")
		.replace(/[^\w-]+/g, "");
};

export const convertRange = (value, r1, r2) => {
	return ((value - r1[0]) * (r2[1] - r2[0])) / (r1[1] - r1[0]) + r2[0];
};

export const isOverflown = ({
	clientWidth,
	clientHeight,
	scrollWidth,
	scrollHeight,
}) => {
	return scrollHeight > clientHeight || scrollWidth > clientWidth;
};

export const getRandomFloat = (min, max, decimals) => {
	const str = (Math.random() * (max - min) + min).toFixed(decimals);
	return parseFloat(str);
};

export const degreesToRadians = (degrees) => {
	let pi = Math.PI;
	return degrees * (pi / 180);
};

export const getZIndex = (e) => {
	let z = window.getComputedStyle(e).getPropertyValue("z-index");
	if (isNaN(z)) return window.getZIndex(e.parentNode);
	return parseInt(z);
};


export const setCookie = (name,value,days) => {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days*24*60*60*1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

export const getCookie = (name) => {
	var cookie = document.cookie;
	var prefix = name + "=";
	var begin = cookie.indexOf("; " + prefix);
	if (begin == -1) {
		begin = cookie.indexOf(prefix);
		if (begin != 0) return null;
	} else {
		begin += 2;
		var end = document.cookie.indexOf(";", begin);
		if (end == -1) {
			end = cookie.length;
		}
	}
	return unescape(cookie.substring(begin + prefix.length, end));
}

export const eraseCookie = (name) => {   
	document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export const isScrolledIntoView = (el) => {
	var rect = el.getBoundingClientRect();
	var elemTop = rect.top;
	var elemBottom = rect.bottom;

	// Only completely visible elements return true:
	var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
	// Partially visible elements return true:
	//isVisible = elemTop < window.innerHeight && elemBottom >= 0;
	return isVisible;
}



export const horizontalLoop = (items, config) => {
	items = gsap.utils.toArray(items);
	config = config || {};
	let onChange = config.onChange,
		lastIndex = 0,
		tl = gsap.timeline({repeat: config.repeat, onUpdate: onChange && function() {
				let i = tl.closestIndex();
				if (lastIndex !== i) {
					lastIndex = i;
					onChange(items[i], i);
				}
			}, paused: config.paused, defaults: {ease: "none"}, onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)}),
		length = items.length,
		startX = items[0].offsetLeft,
		times = [],
		widths = [],
		spaceBefore = [],
		xPercents = [],
		curIndex = 0,
		indexIsDirty = false,
		center = config.center,
		pixelsPerSecond = (config.speed || 1) * 100,
		snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
		timeOffset = 0,
		container = center === true ? items[0].parentNode : gsap.utils.toArray(center)[0] || items[0].parentNode,
		totalWidth,
		getTotalWidth = () => items[length-1].offsetLeft + xPercents[length-1] / 100 * widths[length-1] - startX + spaceBefore[0] + items[length-1].offsetWidth * gsap.getProperty(items[length-1], "scaleX") + (parseFloat(config.paddingRight) || 0),
		populateWidths = () => {
			let b1 = container.getBoundingClientRect(), b2;
			items.forEach((el, i) => {
				widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
				xPercents[i] = snap(parseFloat(gsap.getProperty(el, "x", "px")) / widths[i] * 100 + gsap.getProperty(el, "xPercent"));
				b2 = el.getBoundingClientRect();
				spaceBefore[i] = b2.left - (i ? b1.right : b1.left);
				b1 = b2;
			});
			gsap.set(items, { // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
				xPercent: i => xPercents[i]
			});
			totalWidth = getTotalWidth();
		},
		timeWrap,
		populateOffsets = () => {
			timeOffset = center ? tl.duration() * (container.offsetWidth / 2) / totalWidth : 0;
			center && times.forEach((t, i) => {
				times[i] = timeWrap(tl.labels["label" + i] + tl.duration() * widths[i] / 2 / totalWidth - timeOffset);
			});
		},
		getClosest = (values, value, wrap) => {
			let i = values.length,
				closest = 1e10,
				index = 0, d;
			while (i--) {
				d = Math.abs(values[i] - value);
				if (d > wrap / 2) {
					d = wrap - d;
				}
				if (d < closest) {
					closest = d;
					index = i;
				}
			}
			return index;
		},
		populateTimeline = () => {
			let i, item, curX, distanceToStart, distanceToLoop;
			tl.clear();
			for (i = 0; i < length; i++) {
				item = items[i];
				curX = xPercents[i] / 100 * widths[i];
				distanceToStart = item.offsetLeft + curX - startX + spaceBefore[0];
				distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
				tl.to(item, {xPercent: snap((curX - distanceToLoop) / widths[i] * 100), duration: distanceToLoop / pixelsPerSecond}, 0)
				.fromTo(item, {xPercent: snap((curX - distanceToLoop + totalWidth) / widths[i] * 100)}, {xPercent: xPercents[i], duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond, immediateRender: false}, distanceToLoop / pixelsPerSecond)
				.add("label" + i, distanceToStart / pixelsPerSecond);
				times[i] = distanceToStart / pixelsPerSecond;
			}
			timeWrap = gsap.utils.wrap(0, tl.duration());
		},
		refresh = (deep) => {
			let progress = tl.progress();
			tl.progress(0, true);
			populateWidths();
			deep && populateTimeline();
			populateOffsets();
			deep && tl.draggable ? tl.time(times[curIndex], true) : tl.progress(progress, true);
		},
		proxy;
	gsap.set(items, {x: 0});
	populateWidths();
	populateTimeline();
	populateOffsets();
	window.addEventListener("resize", () => refresh(true));
	function toIndex(index, vars) {
		vars = vars || {};
		(Math.abs(index - curIndex) > length / 2) && (index += index > curIndex ? -length : length); // always go in the shortest direction
		let newIndex = gsap.utils.wrap(0, length, index),
			time = times[newIndex];
		if (time > tl.time() !== index > curIndex && index !== curIndex) { // if we're wrapping the timeline's playhead, make the proper adjustments
			time += tl.duration() * (index > curIndex ? 1 : -1);
		}
		if (time < 0 || time > tl.duration()) {
			vars.modifiers = {time: timeWrap};
		}
		curIndex = newIndex;
		vars.overwrite = true;
		gsap.killTweensOf(proxy);    
		return vars.duration === 0 ? tl.time(timeWrap(time)) : tl.tweenTo(time, vars);
	}
	tl.toIndex = (index, vars) => toIndex(index, vars);
	tl.closestIndex = setCurrent => {
		let index = getClosest(times, tl.time(), tl.duration());
		if (setCurrent) {
			curIndex = index;
			indexIsDirty = false;
		}
		return index;
	};
	tl.current = () => indexIsDirty ? tl.closestIndex(true) : curIndex;
	tl.next = vars => toIndex(tl.current()+1, vars);
	tl.previous = vars => toIndex(tl.current()-1, vars);
	tl.times = times;
	tl.progress(1, true).progress(0, true); // pre-render for performance
	if (config.reversed) {
		tl.vars.onReverseComplete();
		tl.reverse();
	}
	if (config.draggable && typeof(Draggable) === "function") {
		proxy = document.createElement("div")
		let wrap = gsap.utils.wrap(0, 1),
			ratio, startProgress, draggable, dragSnap, lastSnap, initChangeX, wasPlaying,
			align = () => tl.progress(wrap(startProgress + (draggable.startX - draggable.x) * ratio)),
			syncIndex = () => tl.closestIndex(true);
		draggable = Draggable.create(proxy, {
			trigger: items[0].parentNode,
			type: "x",
			onPressInit() {
		let x = this.x;
				gsap.killTweensOf(tl);
		wasPlaying = !tl.paused();
		tl.pause();
				startProgress = tl.progress();
				refresh();
				ratio = 1 / totalWidth;
		initChangeX = (startProgress / -ratio) - x;
				gsap.set(proxy, {x: startProgress / -ratio});
			},
			onDrag: align,
			onThrowUpdate: align,
	overshootTolerance: 0,
			snap(value) {
		//note: if the user presses and releases in the middle of a throw, due to the sudden correction of proxy.x in the onPressInit(), the velocity could be very large, throwing off the snap. So sense that condition and adjust for it. We also need to set overshootTolerance to 0 to prevent the inertia from causing it to shoot past and come back
		if (Math.abs(startProgress / -ratio - this.x) < 10) {
		return lastSnap + initChangeX
		}
				let time = -(value * ratio) * tl.duration(),
					wrappedTime = timeWrap(time),
					snapTime = times[getClosest(times, wrappedTime, tl.duration())],
					dif = snapTime - wrappedTime;
				Math.abs(dif) > tl.duration() / 2 && (dif += dif < 0 ? tl.duration() : -tl.duration());
		lastSnap = (time + dif) / tl.duration() / -ratio;
				return lastSnap;
			},
			onRelease() {
				syncIndex();
				draggable.isThrowing && (indexIsDirty = true);
			},
			onThrowComplete: () => {
		syncIndex();
		wasPlaying && tl.play();
	}
		})[0];
		tl.draggable = draggable;
	}
	tl.closestIndex(true);
	lastIndex = curIndex;
	onChange && onChange(items[curIndex], curIndex);
	return tl;
}